import React, { useEffect, useState } from "react";
import Footer from '../Components/Footer';
import NaviBarv2 from '../Components/NaviBarv2';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import { Container } from 'react-bootstrap';
import sem_a from "../images/news/sem_a.PNG";


export function Sem_s() {


  return (
    <>
      <NaviBarv2 />
      <Container>
        <div><img src={sem_a} align="left" width={500}></img></div>
        <div className="row my-4 ps-4">
          <h1>19 июня пройдёт семинар лаборатории на тему «Сравнительный анализ подходов к решению обратной задачи реконструкции изображений в эмиссионной медицинской томографии»</h1>
        </div>
        <br></br>
        <hr />
        <div className="row my-4"><p className="lead">
        Количественные оценки накопления радиофармпрепарата в патологических очагах при обследовании методом однофотонной эмиссионной компьютерной томографии (ОФЭКТ) имеют ключевое значение для определения стадии заболевания и планирования радионуклидной терапии. В данной работе выполнено сравнение двух алгоритмов реконструкции изображений: стандартного итерационного алгоритма Ordered Subset Expectation Maximization (OSEM), которым оснащено большинство ОФЭКТ-установок, и регуляризированного алгоритма реконструкции на основе байесовского подхода Maximum A Posteriori (MAP) с априорной информацией в виде функционала энтропии (MAP-Ent). Исследования проводились методом имитационного компьютерного моделирования in silico с использованием цифрового двойника вещественного фантома NEMA IEC. Оценка точности проводилась по коэффициенту восстановления, равный отношению максимального значения полученного решения в очаге к его точной величине. Результаты показали, что метод MAP-Ent:<br></br>
•	обеспечивает более высокую количественную точность,<br></br>
•	уменьшает влияние краевых артефактов по сравнению с OSEM,<br></br>
•	позволяет контролировать артефакты за счёт выбора параметра регуляризации.<br></br>
Таким образом, регуляризированный алгоритм MAP-Ent демонстрирует преимущества перед стандартным OSEM и может быть полезен для повышения точности диагностики и планирования терапии.
</p></div>
        <div className="row my-4"><p className="lead">Докладчик: <b>Нестерова Ангелина Витальевна.</b></p></div>
        <div className="row my-4"><p className="lead">Время: 16:00 новосибирского времени (12:00 Мск).</p></div>
        <div className="row my-4"><p className="lead">Семинар будет проходить в онлайн формате в Zoom. Присоединиться можно по <a rel="noopener" target="_blank" href="https://us02web.zoom.us/j/8615596919">ссылке.</a></p></div>
        <div className="row my-4"><p className="lead">*Перед подключением просьба написать свои Имя и Фамилию.</p></div>
        <div className="row my-4"><p className="lead">Все проведённые семинары выложены в <a rel="noopener" target="_blank" href="Sem_Compl">архиве</a>.</p></div>
        <div className="row my-4"><p>17.06.2025</p></div>
      </Container>
      <Footer />
    </>
  );
}